import { createSettingsParams, SettingsParamType } from '@wix/tpa-settings';

export type MenusSettingsParams = {
  showUnavailableOptions: SettingsParamType.Boolean;
  showExpired: SettingsParamType.Boolean;
  showUnavailableAndExpiredLast: SettingsParamType.Boolean;
  sortedMenuIds: SettingsParamType.Text;
};

export const menusSettingsParams = createSettingsParams<MenusSettingsParams>({
  showUnavailableOptions: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
  },
  showExpired: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
  },
  showUnavailableAndExpiredLast: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
  },
  sortedMenuIds: {
    type: SettingsParamType.Text,
    getDefaultValue: () => '',
  },
});
